import { useCanSubmit } from '@/app/components/questionnaireV2/hooks/use-can-submit';
import { BaseNextButton, type BaseNextButtonProps } from './base-next-button';

interface NextButtonProps extends Omit<BaseNextButtonProps, 'disabled'> {
  disabled?: boolean;
}

export function NextButton({ onNext, variant = 'primary', text, style, disabled }: NextButtonProps) {
  const canSubmit = useCanSubmit();
  const isDisabled = disabled !== undefined ? disabled : !canSubmit;

  return <BaseNextButton onNext={onNext} variant={variant} text={text} style={style} disabled={isDisabled} />;
} 
